import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_at4bwf6pjp: FaireBrandEntity = {
  token: "b_at4bwf6pjp",
  type: "brand",
  name: "Keystone Crystals",
  avatarUrl:
    "https://cdn.faire.com/fastly/35ed6e62b6365030dc610a4a6e9675824ba93bc6e6da69b2b4f8b5a1a27fdac3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ee014e728e9c932309f608485f66dfbba93af71c04f6d717a7275f0fa664e145.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/35ed6e62b6365030dc610a4a6e9675824ba93bc6e6da69b2b4f8b5a1a27fdac3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ee014e728e9c932309f608485f66dfbba93af71c04f6d717a7275f0fa664e145.jpeg",
  location: "Kanab, UT, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 676,
  isTopShop: true,
  isInsider: true,
  description:
    "Your source for Crystals with fast fulfillment⚡⚡⚡1-3 business days from Kanab Utah ❤️ we made the move to Kanab Utah in 2018 and we loved the red cliff hills ❤️ the grounding of the red earth called us home and with a abundant of crystal shops in Southern Utah made it easy to set up distribution for our passion of shopping for crystals  for you ❤️ much love and happy shopping \n\n\n\n\n\n\n\n\n\n\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:28.838Z",
    importedBy: "entity-db-cli",
  },
};
